import React from 'react';
import Couriers from '../../components/organisms/Couriers/Couriers';

const ActivationList = () => {
    return <Couriers url="/courier/pre-active-list" route="activation" />;
};

export default ActivationList;
